// extracted by mini-css-extract-plugin
export default {"flamegraphPane":"styles_flamegraphPane__JND98","fitModeItem":"styles_fitModeItem__34fOu","sandwichItem":"styles_sandwichItem__zgtHe"};